import React from "react"
import { ReportAPI } from "../../lib/utils"
import ReportForm from "./ReportForm"

export default function LoanGeneralityReport() {
  return <ReportForm reportAPI={ ReportAPI.LOAN_GENERALITY } />
}



// WEBPACK FOOTER //
// ./src/components/Reports/LoanGeneralityReport.js